import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import {
  createSession,
  getActiveSession,
  getInventoryPosConfig,
  getManagers,
  logoutSession,
  tableLayoutAvailability,
  validateManagerPin,
} from "../../../../../../config/Services";
import { setInLocalStorage } from "../../../../../../utils/localStorageHelpers";
import {
  addLicense,
  addadvance,
  addmanagerpin,
  addmanageruidx,
  addpin,
} from "../../../all-products/redux/Actions/SessionActions";
import { getMobilePos } from "../../../all-products/redux/Reducers/paginationReducer";
import { getAmount, getLicense } from "../../../all-products/redux/Reducers/sessionReducer";
import { useSnackbar } from "../../../hooks/SnackbarProvider";
import useGetDevice from "../../../hooks/useGetDevice";
import { emit } from "react-native-react-bridge/lib/web";
import PalletLogo from "../../../../../../assets/images/Pallet-logo-blue-transparent (2).png";
import ShieldIcon from "@mui/icons-material/Shield";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import LogoutIcon from "@mui/icons-material/Logout";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import CircularProgress from "@mui/material/CircularProgress";
import "./indexV2.css";

export const AuthenticationV2 = () => {
  const showSnackbar = useSnackbar();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const selectedLicense = useSelector(getLicense);
  const amount = useSelector(getAmount);
  const isMobilePos = useSelector(getMobilePos);
  const retailUserDetails = JSON.parse(localStorage.getItem("retailUserDetails") || "{}");
  const orgId = localStorage.getItem("orgId");
  const contextId = localStorage.getItem("locId");
  const locName = localStorage.getItem("LocName") || "Location";
  const orgName = localStorage.getItem("orgName") || "Organization";
  const retailType = localStorage.getItem("retailType") || "";
  const daySessionId = localStorage.getItem("daySessionId");
  const uidx = retailUserDetails?.uidx;
  const mobileNumber = retailUserDetails?.mobileNumber;
  const userName = retailUserDetails?.firstName + " " + retailUserDetails?.secondName;
  const isMobile = useGetDevice();

  const [posPin, setPosPin] = useState("");
  const [posPinVisible, setPosPinVisible] = useState(false);
  const [managerPin, setManagerPin] = useState("");
  const [managerPinVisible, setManagerPinVisible] = useState(false);
  const [managers, setManagers] = useState([]);
  const [selectedManager, setSelectedManager] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    getManagers({ contextId }).then((res) => {
      const list =
        res?.data?.data?.map((e) => ({
          value: e?.mobile_number,
          label: e?.first_name,
        })) || [];
      setManagers(list);
    });
  }, []);

  const goToHomepage = () => {
    if (retailType === "RESTAURANT") {
      tableLayoutAvailability(contextId)
        .then((res) => {
          localStorage.setItem("layoutId", res?.data?.object?.[0]?.layoutId);
          return getInventoryPosConfig(orgId, contextId);
        })
        .then((configRes) => {
          if (configRes?.data) {
            localStorage.setItem("isInventoryConfigSet", configRes?.data?.data?.es === 0);
            const enable = configRes?.data?.data?.data?.enableMandatoryStockCount;
            if (enable !== undefined)
              localStorage.setItem("enableMandatoryStockCount", enable.toString());
          }
        })
        .catch(() => {})
        .finally(() => navigate("/dashboard"));
    } else {
      navigate("/dashboard");
    }
  };

  const handleStartSession = () => {
    if (!posPin) {
      showSnackbar("Enter your PIN to proceed", "error");
      return;
    }
    if (!selectedManager) {
      showSnackbar("Select an approving manager", "error");
      return;
    }
    if (!managerPin) {
      showSnackbar("Enter manager PIN to proceed", "error");
      return;
    }

    setLoader(true);
    // Step 1: validate POS user PIN
    validateManagerPin({ mobile: mobileNumber, primaryPassword: posPin })
      .then(() => {
        // Step 2: validate manager PIN
        return validateManagerPin({ mobile: selectedManager.value, primaryPassword: managerPin });
      })
      .then(() => {
        // Step 3: create session
        const licenseId =
          selectedLicense?.licenseId || localStorage.getItem("selectedLicenseId") || "";
        const licenseName =
          selectedLicense?.licenseName || localStorage.getItem("selectedLicenseName") || "";
        const payload = {
          uidx,
          role: "CASHIER",
          organizationId: orgId,
          locationId: contextId,
          licenseName,
          licenseId,
          cashDrawerStartingAmount: amount === "" ? "0" : amount,
          createdBy: "manager",
          createdByName: userName,
          posType: isMobile ? "MPOS" : "POS",
        };
        return createSession(payload);
      })
      .then((res) => {
        if (res?.data?.es === 1) {
          showSnackbar(res?.data?.message, "error");
          setLoader(false);
          dispatch(addLicense({ licenseId: "", licenseName: "" }));
          dispatch(addadvance(""));
          dispatch(addpin(""));
          dispatch(addmanagerpin(""));
          dispatch(addmanageruidx(""));
          setTimeout(() => navigate("/session-page/start-day"), 2000);
          return;
        }
        showSnackbar("Session started successfully", "success");
        // Step 4: get active session and update localStorage
        return getActiveSession(uidx, contextId, daySessionId)
          .then((sessionRes) => {
            if (sessionRes?.data?.statusCode !== 300) {
              if (sessionRes?.data?.hasOwnProperty("machines")) {
                localStorage.setItem("machineId", sessionRes?.data?.machines?.[0].machineId || 0);
                if (
                  localStorage.getItem("loggedInCount") === null ||
                  localStorage.getItem("loggedInCount") === undefined
                ) {
                  localStorage.setItem("storeMode", "ONLINE");
                  localStorage.setItem("cartStoreMode", "ONLINE");
                  localStorage.setItem("loggedInCount", 1);
                }
              }
              localStorage.setItem("sessionId", sessionRes?.data?.userSession?.sessionId);
              localStorage.setItem("licenseId", sessionRes?.data?.userSession?.licenseId);
              setInLocalStorage("licenseName", sessionRes?.data?.userSession?.licenseName);
              isMobilePos &&
                emit({
                  type: "localData",
                  data: {
                    sessionId: sessionRes?.data?.userSession?.sessionId,
                    licenseId: sessionRes?.data?.userSession?.licenseId,
                    licenseName: sessionRes?.data?.userSession?.licenseName,
                  },
                });
            }
            setLoader(false);
            goToHomepage();
          })
          .catch(() => {
            setLoader(false);
            goToHomepage();
          });
      })
      .catch((err) => {
        showSnackbar(err?.response?.data?.message || err?.message, "error");
        setLoader(false);
      });
  };

  const handleLogout = () => {
    logoutSession()
      .catch(() => {})
      .finally(() => {
        Object.keys(localStorage).forEach((key) => {
          if (key !== "printerConfig") localStorage.removeItem(key);
        });
        navigate("/");
        window.location.reload();
      });
  };

  const canSubmit = posPin && selectedManager && managerPin;

  return (
    <div className="au-page">
      <div className="au-outer">
        {/* Top bar */}
        <div className="au-topbar">
          <img src={PalletLogo} alt="Pallet" className="au-topbar-logo" />
          <span className="au-topbar-badge">POS USER APPROVAL</span>
        </div>

        <div className="au-panels">
          {/* ── Left panel ── */}
          <div className="au-left">
            <button className="au-back-btn" onClick={() => navigate("/session-page/opening")}>
              ← Back to system health
            </button>

            <p className="au-section-tag">COUNTER APPROVAL</p>
            <h2 className="au-left-title">POS user sign-in</h2>
            <p className="au-left-desc">
              Enter the staff PIN, choose the approving manager, and confirm the manager PIN to
              unlock billing access for this session.
            </p>

            {/* Session info card */}
            <div className="au-info-card">
              <div className="au-info-top">
                <div className="au-info-top-left">
                  <div className="au-info-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#fff"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      aria-hidden="true"
                    >
                      <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                      <path d="m9 12 2 2 4-4"></path>
                    </svg>
                  </div>
                  <div>
                    <p className="au-info-terminal">
                      {selectedLicense?.licenseName ||
                        localStorage.getItem("selectedLicenseName") ||
                        "Terminal"}
                    </p>
                    <p className="au-info-sub">Terminal access</p>
                  </div>
                </div>
                <div className="au-info-top-badges">
                  <span className="au-badge-location">{locName}</span>
                  <span className="au-badge-org">{orgName}</span>
                </div>
              </div>
              <div className="au-info-bottom">
                <div className="au-info-stat">
                  <p className="au-info-stat-label">CHANNEL</p>
                  {/* <p className="au-info-stat-value">{ retailType || "—"}</p> */}
                  <p className="au-info-stat-value">{"Retail OS"}</p>
                </div>
                <div className="au-info-stat green">
                  <p className="au-info-stat-label">OPENING CASH</p>
                  <p className="au-info-stat-value">₹ {amount || "0"}</p>
                </div>
              </div>
            </div>

            {/* Bottom actions */}
            <div className="au-bottom-actions">
              <button
                className="au-action-btn location"
                onClick={() => navigate("/products/location")}
              >
                <LocationOnIcon sx={{ fontSize: 15 }} /> Change Location
              </button>
              <button className="au-action-btn logout" onClick={handleLogout}>
                <LogoutIcon sx={{ fontSize: 15 }} /> Logout
              </button>
            </div>
          </div>

          {/* ── Right panel ── */}
          <div className="au-right">
            <div className="au-form-card">
              <p className="au-right-section-tag">VERIFICATION STEPS</p>
              <h2 className="au-right-title">Manager-approved sign-in</h2>

              <div className="au-fields">
                {/* POS User PIN */}
                <div>
                  <label className="au-field-label">POS USER PIN</label>
                  <div className="au-input-wrap">
                    {/* <input
                      className="au-input"
                      type={posPinVisible ? "text" : "password"}
                      inputMode="numeric"
                      placeholder="Enter 4-digit staff PIN"
                      autoFocus
                      onChange={(e) => setPosPin(e.target.value)}
                    /> */}
                    <input
                      className="au-input"
                      type={posPinVisible ? "text" : "password"}
                      inputMode="numeric"
                      placeholder="Enter 4-digit staff PIN"
                      autoFocus
                      value={posPin}
                      maxLength={4}
                      onChange={(e) => {
                        const onlyDigits = e.target.value.replace(/[^0-9]/g, "");
                        setPosPin(onlyDigits);
                      }}
                    />
                    <button
                      type="button"
                      className="au-eye-btn"
                      onClick={() => setPosPinVisible((v) => !v)}
                    >
                      {posPinVisible ? (
                        <VisibilityOff fontSize="small" />
                      ) : (
                        <Visibility fontSize="small" />
                      )}
                    </button>
                  </div>
                </div>

                {/* Manager dropdown */}
                <div>
                  <label className="au-field-label">MANAGER</label>
                  <div className="au-dropdown-wrap" onClick={() => setDropdownOpen((v) => !v)}>
                    <span className={`au-dropdown-value ${!selectedManager ? "placeholder" : ""}`}>
                      {selectedManager ? selectedManager?.label : "Select approving manager"}
                    </span>
                    <KeyboardArrowDownIcon
                      className={`au-dropdown-arrow ${dropdownOpen ? "open" : ""}`}
                    />
                    {dropdownOpen && (
                      <div className="au-dropdown-list">
                        {managers?.map((m) => (
                          <div
                            key={m?.value}
                            className="au-dropdown-item"
                            onClick={(e) => {
                              e.stopPropagation();
                              setSelectedManager(m);
                              dispatch(addmanageruidx(m?.value));
                              setDropdownOpen(false);
                            }}
                          >
                            {m?.label}
                          </div>
                        ))}
                        {managers?.length === 0 && (
                          <div className="au-dropdown-item empty">No managers found</div>
                        )}
                      </div>
                    )}
                  </div>
                </div>

                {/* Manager PIN */}
                <div>
                  <label className="au-field-label">MANAGER PIN</label>
                  <div className="au-input-wrap">
                    {/* <input
                      className="au-input"
                      type={managerPinVisible ? "text" : "password"}
                      inputMode="numeric"
                      placeholder="Enter 4-digit manager PIN"
                      onChange={(e) => {
                        setManagerPin(e.target.value);
                        dispatch(addmanagerpin(e.target.value));
                      }}
                    /> */}
                    <input
                      className="au-input"
                      type={managerPinVisible ? "text" : "password"}
                      inputMode="numeric"
                      placeholder="Enter 4-digit manager PIN"
                      value={managerPin}
                      maxLength={4}
                      onChange={(e) => {
                        const onlyDigits = e.target.value.replace(/[^0-9]/g, "");
                        setManagerPin(onlyDigits);
                        dispatch(addmanagerpin(onlyDigits));
                      }}
                    />
                    <button
                      type="button"
                      className="au-eye-btn"
                      onClick={() => setManagerPinVisible((v) => !v)}
                    >
                      {managerPinVisible ? (
                        <VisibilityOff fontSize="small" />
                      ) : (
                        <Visibility fontSize="small" />
                      )}
                    </button>
                  </div>
                </div>
              </div>

              {/* Start session button */}
              <button
                className="au-submit-btn"
                onClick={handleStartSession}
                disabled={!canSubmit || loader}
              >
                {loader ? (
                  <CircularProgress size={18} sx={{ color: "#fff" }} />
                ) : (
                  <>
                    Start session <ArrowForwardIcon fontSize="small" />
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthenticationV2;
